import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enTranslations from "../public/locales/en/translation.json";
import esTranslations from "../public/locales/es/translation.json";

/**
 * Some locale files mistakenly wrap the namespace as `{ "translation": { ... } }`.
 * i18next expects the imported JSON to be the inner object for `translation` NS.
 */
function normalizeTranslationFile(
	data: Record<string, unknown>,
): Record<string, unknown> {
	const inner = data.translation;
	if (
		typeof inner === "object" &&
		inner !== null &&
		!Array.isArray(inner) &&
		Object.keys(data).length === 1
	) {
		return inner as Record<string, unknown>;
	}
	return data;
}

const enBundle = normalizeTranslationFile(
	enTranslations as Record<string, unknown>,
);
const esBundle = normalizeTranslationFile(
	esTranslations as Record<string, unknown>,
);

/**
 * Bundled JSON is used only for unauthenticated routes (restore on logout).
 * Authenticated app replaces `translation` entirely via applyAuthenticatedTranslations()
 * from GET /field-infos/localizations. HttpBackend is not used — it was merging
 * /public/locales/... back over the API bundle and dropping keys like descriptionText.
 */
export const resources = {
	en: {
		translation: enBundle,
	},
	es: {
		translation: esBundle,
	},
} as const;

export const defaultNS = "translation";

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		defaultNS,
		fallbackLng: "en",
		supportedLngs: ["en", "es"],
		load: "languageOnly",
		detection: {
			order: ["querystring", "navigator", "localStorage"],
			lookupQuerystring: "lng",
			caches: ["localStorage"],
		},
		interpolation: {
			escapeValue: false,
		},
		// Default react-i18next bindI18nStore is '' — components would not re-render when
		// applyAuthenticatedTranslations() replaces the translation namespace via addResourceBundle.
		react: {
			bindI18nStore: "added removed",
		},
	});

export default i18next;
